<template>
  <div class="content">
    <Page>
      <transition name="fade" mode="out-in">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
      </transition>
      <transition name="fade" mode="out-in">
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </transition>
    </Page>
  </div>
</template>
<script>
  export default {
      data(){
      }
  }
</script>
<style lang="less" scoped>
  .content{
    width:100%;
    height:100%;
  }
  .content{
    width:100%;
    height:100%;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/globalComponent/routerView/content.vue